export default __webpack_public_path__ + "static/media/quantisal_step6.375b8780.png";